import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { CreatePlayerFormComponent } from "./create-player-form.component";
import { NamingConventionService } from "@mipro/services/naming-convention.service";
import { PatientLogin } from "@main/users";
import { MessageService } from "primeng/api";
import { Message } from "@bbwt/classes";

@Component({
    selector: "create-player-dialog",
    template: `<p-dialog
        [(visible)]="visible"
        appendTo="body"
        [closable]="true"
        [closeOnEscape]="false"
        [modal]="true"
        header="Create {{namingConvService.endUserSingular}}"
        [style]="{ 'max-width': '760px', width: '100%' }">
        <ng-template pTemplate="content">
            <create-player-form
                [data]="data"
                [inputsGroupStyle]="{ 'max-width': '100%' }"
                (playerCreated)="close($event)"
                (cancel)="visible = false"
                (emailNotSent)="showWarningEmailMessage()"></create-player-form>
        </ng-template>
    </p-dialog>`
})
export class CreatePlayerDialogComponent {
    private _visible = false;

    constructor(
        public namingConvService: NamingConventionService,
        private messageService: MessageService
    ) {}

    @ViewChild(CreatePlayerFormComponent)
    createPlayerForm: CreatePlayerFormComponent;

    @Input() data: PatientLogin;

    @Input()
    set visible(visible: boolean) {
        this._visible = visible;
        if (visible) {
            this.createPlayerForm?.playerForm.reset();
        }
        this.visibleChange.emit(visible);
    }
    get visible() {
        return this._visible;
    }

    @Output() readonly visibleChange = new EventEmitter<boolean>();
    @Output() readonly playerCreated = new EventEmitter<PatientLogin>();

    close(patient: PatientLogin) {
        this.playerCreated.emit(patient);
        this.visible = false;
    }

    showWarningEmailMessage(){
        this.messageService.add(Message.Warning("Login created successfully.\nFailed to send invitation due to an invalid email.", "User Invitation"));
    }
}
